// Confirm shown when a save turns on auto-unblock for a resource (OTC-3055).
// The unblock sweep reopens any slot with status Blocked inside the resource's
// hours, including slots staff blocked by hand; custom statuses are exempt.
// Shared by ResourceDrawer and the create/edit schedule pages so the copy
// lives in one place.
export const AUTO_UNBLOCK_WARNING = {
  title: 'Auto-unblock reopens blocked slots',
  message: "Any slot marked Blocked during this resource's hours can reopen when bookings change and capacity allows, including slots your team blocked by hand. To keep a slot closed, give it a custom status set to hidden or sold out online. Custom statuses are exempt from autoblocking. Create them in Calendar under the gear menu, Booking slot settings, Custom statuses.",
  variant: 'warning',
  confirmText: 'Continue',
  cancelText: 'Cancel',
};
